<template>
    <div class="mx-auto col-md-8 col-sm-12 header-margin pt-4">
        <div class="text-left text-md-center">
            <h3>購入代金の送付処理で問題が起こりました。</h3>
            <h4 class="mt-4">問い合わせ画面より送付処理の詳細をお問い合わせください。</h4>
        </div>
        <div class="form-row py-3 justify-content-center">
            <div class="col-md-3">
                <router-link :to="{ name: 'home' }" class="btn btn-primary btn-block">
                    {{ $t('hec.failureModule.closeBtn') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MembershipFeeFailure',

        components: {},

        mounted() {},

        data() {
            return {
            }
        },

        created() {
        },

        methods: {
        }
    }
</script>

<style>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

</style>
